import React, { FC } from 'react'

import clsx from 'clsx'

interface Props {
  className?: string
  errors?: { message: string | null; type: string }[]
  id?: string
}

const FormErrors: FC<Props> = ({ errors = [], className, id }) => (
  <div
    aria-live="polite"
    className={clsx('checkout-form__errors', className)}
    id={id}
    role="alert"
    style={{ ...(errors.length ? { display: 'block' } : undefined) }}
  >
    {errors.map(({ message }, index) => (
      <p key={index}>{message}</p>
    ))}
  </div>
)

export default FormErrors
